<template>
    <div class="main">
        <div class="text-card" v-if="role === 'driver'">预计人工审批1-3个工作日，审批通过后即成为早拼司机，立享每日同行上班。</div>
        <div class="text-card" v-else>预计人工审批1-3个工作日，审批通过后即可享受每日同行上班。</div>
        <div class="body">
            <div style="font-weight: 700;">请填写以下申请信息</div>
            <div style="color: #999999;font-size: 12px;">申请提交后等待审批通过即绑定司机成功，可每日同行上班</div>
            <van-form @submit="onSubmit">
                <van-field
                    v-model="form.Name"
                    name="Name"
                    label="姓名"
                    placeholder="请输入真实姓名"
                    readonly
                    clearable
                    :rules="[{ required: true }]"
                />
                <van-field
                    v-model="form.Phone"
                    name="Phone"
                    label="电话"
                    placeholder="请输入正确手机号码"
                    clearable
                    :rules="[{ required: true }]"
                />
                <template v-if="role === 'driver'">
                    <van-field
                        v-model="form.CarName"
                        name="CarName"
                        label="品牌车型"
                        placeholder="请输入品牌车型"
                        clearable
                        :rules="[{ required: true }]"
                    />
                    <van-field
                        v-model="form.CarNum"
                        name="CarNum"
                        label="车牌号码"
                        placeholder="请输入车牌号码"
                        clearable
                        :rules="[{ pattern, required: true }]"
                    />
                    <div style="display:flex;justify-content: space-between;">
                        <div style="background-color:#F5F5F5;padding: 12px 0 0 12px;border-radius: 4px;width: 45%;">
                            <div>车辆颜色</div>
                            <van-field
                                v-model="form.CarColor"
                                name="CarColor"
                                placeholder="请填写车辆颜色"
                                clearable
                                :rules="[{ required: true }]"
                                style="padding:0;width: 90%;"/>
                        </div>
                        <div span="12" style="background-color:#F5F5F5;padding: 12px 0 0 12px;border-radius: 4px;width: 45%;">
                            <div>座位</div>
                            <van-field name="CarSeat" style="padding:0;width: 90%;">
                                <template #input>
                                    <van-stepper v-model="form.CarSeat" theme="round" button-size="22"/>
                                </template>
                            </van-field>
                        </div>
                    </div>
                </template>
                <van-field
                    v-model="form.DepartTime"
                    name="DepartTime"
                    :label="role === 'driver' ? '发车时间' : '上车时间'"
                    :placeholder="role === 'driver' ? '请选择发车时间' : '请选择上车时间'"
                    readonly
                    clearable
                    right-icon="arrow"
                    :rules="[{ required: true }]"
                    @click="showTime = true"
                />
                <van-popup v-model="showTime" position="bottom">
                    <van-datetime-picker
                        type="time"
                        :min-hour="6"
                        :max-hour="8"
                        @confirm="onTime"
                        @cancel="showTime = false"
                    />
                </van-popup>
                <van-field
                    v-model="form.Way"
                    type="textarea"
                    name="Way"
                    :placeholder="role === 'driver' ? '请根据途径地顺序选择' : '请选择上车地点'"
                    readonly
                    clearable
                    right-icon="arrow"
                    :rules="[{ required: true }]"
                    @click="showWay = true"
                />
                <div style="color: #F22222;font-size: 12px;">*说明：以上信息一旦提交，不得随意更改。</div>
                <div style="margin: 16px 0 8px 0;">
                    <template v-if="role === 'driver'">
                        <van-button round block color="#FEB013" native-type="submit">提交申请至车队审批</van-button>
                    </template>
                    <template v-else>
                        <van-button round block color="#FEB013" native-type="submit">提交申请绑定司机</van-button>
                    </template>
                </div>
            </van-form>
        </div>
        <van-popup v-model="showWay" position="bottom" :close-on-click-overlay="false" safe-area-inset-bottom :style="{ height: '95%' }">
            <van-sticky>
                <div class="wayTitle">
                    <div style="color: #999999;" @click="showWay = false">取消</div>
                    <div style="color: #FEB013;" @click="onWay">确定</div>
                </div>
            </van-sticky>
            <div style="padding: 12px;">
                <baidu-map>
                    <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                    <bm-view class="map"></bm-view>
                    <bm-driving
                        location="珠海"
                        :start="LngLat[0] ? LngLat[0] : WXInfo.area === '健树' ? {lat: 21.976413, lng: 113.240499} : { lat:22.396843, lng:113.555596 }"
                        :end="endLngLat"
                        startCity="珠海"
                        endCity="珠海"
                        :auto-viewport="true"
                        :panel="false"
                        :waypoints="LngLat"
                        @searchcomplete="searchcomplete"
                    >
                    </bm-driving>
                </baidu-map>
                <van-tag
                    v-for="(item, index) in result"
                    :key="index"
                    closeable
                    size="medium"
                    color="#FEB013"
                    style="margin-right: 8px;margin-top: 8px;"
                    @close="closeTag(index)"
                >{{item}}</van-tag>
            </div>
            <van-search v-model="searchValue" show-action placeholder="请输入搜索公交车站关键词" @search="searchSite">
                <template #action>
                    <div @click="searchSite">搜索</div>
                </template>
            </van-search>
            <van-checkbox-group v-model="result">
                <van-cell-group>
                    <van-cell
                        v-for="(item, index) in list"
                        clickable
                        :key="index"
                        :title="item.name"
                        @click="toggle(index)"
                    >
                    <template #right-icon>
                        <van-checkbox checked-color="#FEB013" :name="item.name" ref="checkboxes" />
                    </template>
                    </van-cell>
                </van-cell-group>
            </van-checkbox-group>
        </van-popup>
        <div class="company">由营销信息部提供技术支持</div>
    </div>
</template>
<script src="https://unpkg.com/vue-baidu-map"></script>
<script>
export default {
    data() {
        return {
            role: '',
            WXInfo: {},
            form: {},
            showWay: false,
            showRoute: false,
            showTime: false,
            searchValue: '',
            routeTitle: '',
            list: [],
            result: [],
            LngLat: [],
            pattern: /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/,
            endLngLat: { }
        }
    },
    mounted() {
        // const test = {"errno":0,"data":{"area":"健树","errcode":0,"errmsg":"ok","userid":"201755101","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"ozAQBt9Jauj5fMYuM9Q0bNmhaAo8","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
        // this.WXInfo = test.data
        this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
        this.init()
        this.endLngLat = this.WXInfo.area === '健树' ? {lat: 21.976413, lng: 113.240499} : { lat:22.396843, lng:113.555596 }
    },
    methods: {
        isValidWorkOpenId() {
            const oid = this.WXInfo.openid
            return oid != null && String(oid).trim() !== '' && String(oid) !== 'undefined'
        },
        async init () {
            // 兜底成乘客，避免直接打开链接（无 workrole）时写出没有 Role 的档案
            this.role = this.$route.query.workrole || 'passenger'
            const result = await this.getUserInfo()
            if (result.data) {
                let item = result.data
                // localStorage.setItem('Phone', item.Phone)
                // DB 中 Name/Phone 为空时用企微授权字段补全
                this.form = {
                    UserId: this.WXInfo.userid,
                    Name: item.Name || this.WXInfo.name,
                    Phone: item.Phone || this.WXInfo.mobile,
                    CarName: item.CarName,
                    CarNum: item.CarNum,
                    CarColor: item.CarColor,
                    CarSeat: item.CarSeat,
                    Role: this.role,
                    Effictive: this.role === 'driver' ? true : false,
                    Status: false
                }
            } else {
                this.form = {
                    Avatar: this.WXInfo.avatar,
                    UserId: this.WXInfo.userid,
                    Name: this.WXInfo.name,
                    Sex: this.WXInfo.gender === '1' ? '男' : '女',
                    Phone: this.WXInfo.mobile,
                    Role: this.role,
                    Effictive: this.role === 'driver' ? true : false,
                    Status: false
                }
                if (this.isValidWorkOpenId()) {
                    this.form.OpenId = this.WXInfo.openid
                }
                if (this.role === 'driver') {
                    this.form.CarSeat = '4'
                } 
            }
            this.form.Area = this.WXInfo.area
        },
        async onSubmit() {
            if (this.role === 'passenger') {
                delete this.form.CarName
                delete this.form.CarNum
                delete this.form.CarColor
                delete this.form.CarSeat
                this.form.DriverId = this.$route.query.driverid
            }
            const work = await this.postWorkUser(this.form)
            const user = await this.postUserCar(this.form)
            if (work.success && user.success) {
                let message = '消息通知：' +
                    '\n\n日期：' + this.$moment(new Date()).format('YYYY-MM-DD HH:mm') +
                    '\n乘客：' + this.form.Name +
                    '\n手机号码：' + this.form.Phone +
                    '\n上车时间：' + this.form.DepartTime +
                    '\n上车地点：' + this.form.Way + 
                    '\n\n有乘客申请您的拼车，请审核。\n\n' +
                    '<a href="https://pinche.jafron.com/work/audit">审核</a>'
                this.postSendMessage(this.$route.query.driverid, message)
                this.$router.push('/work/index')
            } else {
                this.$toast('数据更新失败')
            }
        },
        searchcomplete (value) {
            if (value.taxiFare) {
                this.form.Distance = value.taxiFare.distance
            }
        },
        searchSite () {
            this.getSiteList(this.searchValue)
        },
        async toggle (index) {
            if (this.role === 'passenger' && this.LngLat.length >= 1) {
                this.$toast('只能选择一个上车地点')
            } else {
                await this.$refs.checkboxes[index].toggle()
                if (this.LngLat.includes(this.list[index].location)) {
                    let key = this.LngLat.indexOf(this.list[index].location)
                    this.LngLat.splice(key, 1)
                } else {
                    this.LngLat.push(this.list[index].location)
                }
            }
        },
        closeTag (key) {
            this.result.splice(key, 1)
            this.LngLat.splice(key, 1)
        },
        onWay () {
            this.showWay = false
            this.form.Way = this.result.toString()
            this.form.LngLat = this.LngLat
        },
        onTime (time) {
            this.form.DepartTime = time
            this.showTime = false
        },
        postWorkUser (data) {
            return this.$request({
                url: this.$api.postWorkUser,
                method: 'POST',
                params: {
                    UserId: this.WXInfo.userid
                },
                data
            })
        },
        postUserCar (data) {
            return this.$request({
                url: this.$api.postUserCar,
                method: 'POST',
                params: {
                    // OpenId: this.WXInfo.openid
                    UserId: this.WXInfo.userid
                },
                data: Object.assign({ UserId: this.WXInfo.userid }, data)
            })
        },
        async getSiteList(value) {
            const result = await this.$request({
                url: this.$api.getBaiDuSiteList,
                method: 'GET',
                params: {
                    name: value
                }
            })
            if (result.data.length > 0) {
                let obj = {}
                // this.list = result.data
                this.list = result.data.reduce((item, next) => {
                    obj[next.name] ? '' : obj[next.name] = true && item.push(next)
                    return item
                }, [])
            } else {
                this.$toast(result.message)
            }
        },
        // 查询用户基础数据（优先企业微信 userid，避免 openid 缺失时 OpenId=undefined 串单）
        getUserInfo() {
            const params = {}
            const uid = this.WXInfo.userid
            if (uid) {
                params.UserId = String(uid)
            } else if (this.isValidWorkOpenId()) {
                params.OpenId = this.WXInfo.openid
            }
            return this.$request({
                url: this.$api.getUserInfoFormWork,
                method: 'GET',
                params
            })
        },
        // 发送消息
        async postSendMessage(userid, message) {
            const result = await this.$request({
                url: this.$api.postSendMessageWX,
                method: 'POST',
                data: {
                    'touser': userid,
                    'msgtype': 'text',
                    'agentid': this.$agentid,
                    'text': { 'content': message }
                }
            })
            if (!result.success) {
                this.$toast(result.message)
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .main {
        height: initial;
        padding: 0 12px;
        background-color: #ffffff;
    }
    .map {
        width: 100%;
        height: 200px;
    }    
    .text-card {
        margin-top: 8px;
        background: rgba(242, 34, 34, 0.1);
        border-radius: 4px;
        padding: 8px 12px;
        color: #F22222;
        font-size: 14px;
    }
    .body {
        padding: 12px 0;
        line-height: 1.5;
    }
    .top-message{
        text-align: center;
    }
    .company {
        text-align: center;
        font-size: 12px;
        padding-bottom: 10px;
    }
    /deep/.van-form .van-cell {
        background-color: #F5F5F5;
        margin: 12px 0;
        border-radius: 4px;
        padding: 10px 12px;
        font-size: 16px;
    }
    /deep/.van-stepper--round .van-stepper__plus {
        background-color: #FEB013;
    }
    /deep/.van-stepper--round .van-stepper__minus {
        color: #FFFFFF;
        background-color: #999999;
        border:initial;
    }
    .wayTitle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #F5F5F5;
        padding: 12px;
        background-color: #FFFFFF;
    }
    .radioBox {
        display: flex;
        justify-content: space-between;
        border-radius: 4px;
        padding: 8px 8px;
        margin: 8px 12px;
        font-size: 14px;
        font-weight: bold;
    }
</style>
